import _ from 'lodash'
import { ArrayLoading, ResponseArray } from '../types'
import { ProductModel, ModelTopology, Model, SectionTableModel } from './types'
import { currentCategoryNone, currentProductClassNone, currentManufacturingSeriesNone, currentProductNone, blankSectionTable, blankEditBase, blankImage } from '../editor/constants'
import { loading, none, blankResponseArray } from '../constants'

import { SectionTableOptions } from '../editor-section/types'

export const loadingProductModel: ArrayLoading<Model> = _.assign([], loading)
export const loadingModelTopology: ArrayLoading<ModelTopology> = _.assign([], loading)

export const blankModel: Model = _.assign({
  PcnCatalogNumber: '',
  Barcode: null,
  Visible: true,
  FingoodTpiMfgMod: '',
  TotalList: 0,
  Tranepcn: '',
  Raypcn: '',
  Ecommerce: false,
  International: false,
  Descriptions: [],
  ModelDimensions: [],
  Notes: [],
  ProductModels: [],
  ModelProductClassTypes: [],
  DivisionModels: [],
  Series: '',
  SapModelDescription: '',
  ProductHierarchy: '',
  Details: {},
  ModelAssociations: [],
  LabelDescriptions: [],
  ChildAssociations: [],
  ParentAssociations: [],
  CustomBuild: false,
  ReplacementPart: false,
  Accessory: false,
  FactoryInstalled: false,
  FieldInstalled: false,
  Image: blankImage,
  LeadTime: 0,
  Configurable: false,
}, blankEditBase)

export const noneModel = _.merge({}, blankModel, none)

export const blankModels: ResponseArray<Model> = _.assign({}, blankResponseArray, { loading: false })
export const loadingModel = _.assign({}, blankModel, loading)
export const loadingModels: ResponseArray<Model> = _.assign({}, blankResponseArray)

export const blankModelTopology: ModelTopology = _.merge({ category: currentCategoryNone, productClass: currentProductClassNone, manufacturingSeries: currentManufacturingSeriesNone, product: currentProductNone, entityType: '', sectionTable: blankSectionTable, sectionTableModelId: -1, productModelId: -1 }, blankEditBase)
export const blankProductModel: ProductModel = _.merge({ PcnCatalogNumber: '', CategoryId: -1, ProductClassId: -1, ManufacturingSeriesId: -1, ProductId: -1, ProductModelId: -1, SectionTableModels: [] }, blankEditBase)
export const blankSectionTableModel: SectionTableModel = _.merge({ SectionId: -1, SectionTabId: -1, SectionTableId: -1, SectionTableModelId: -1, OrderBy: -1 }, blankEditBase)

export const sectionTableOptionNone: SectionTableOptions = { DisplayName: '-- None --', SectionTableId: -1 }
export const sectionTableModelNone: SectionTableModel = _.merge({ SectionId: -1, SectionTabId: -1, SectionTableId: -1, SectionTableModelId: -1, DisplayName: '', OrderBy: -1 }, blankEditBase)
